import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Swal from "sweetalert2";
import { cancelStampedInvoice } from "../../../../../services/CatalogService";

const MOTIVO_OPTIONS = [
  { value: "01", label: "01 - Comprobante emitido con errores con relación" },
  { value: "02", label: "02 - Comprobante emitido con errores sin relación" },
  { value: "03", label: "03 - No se llevó a cabo la operación" },
  { value: "04", label: "04 - Operación nominativa relacionada en la factura global" },
];

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function CancelInvoiceModal({ isOpen, onClose, invoice, razonSocial, onCancelled }) {
  const [motivo, setMotivo] = useState("03");
  const [uuidReemplazo, setUuidReemplazo] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setMotivo("03");
      setUuidReemplazo("");
    }
  }, [isOpen, invoice]);

  if (!invoice) return null;

  const handleCancel = async () => {
    if (motivo === "01" && !uuidReemplazo) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "El UUID de reemplazo es obligatorio cuando el motivo es 01",
      });
      return;
    }

    if (motivo === "01" && uuidReemplazo && !UUID_REGEX.test(uuidReemplazo)) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "El UUID de reemplazo no tiene un formato válido",
      });
      return;
    }

    setLoading(true);
    try {
      await cancelStampedInvoice(invoice.id, {
        motivo,
        uuidReemplazo: motivo === "01" ? uuidReemplazo : undefined,
        razonSocial,
      });

      await Swal.fire({
        icon: "success",
        title: "Factura cancelada",
        text: "La factura ha sido cancelada correctamente",
      });

      onCancelled();
      onClose();
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Error al cancelar la factura";

      Swal.fire({
        icon: "error",
        title: "No se pudo cancelar",
        text: message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={isOpen} onHide={loading ? undefined : onClose} centered>
      <Modal.Header closeButton={!loading}>
        <Modal.Title>Cancelar Factura</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-1">
          <strong>UUID Factura:</strong> {invoice.uuid_stamp || "N/A"}
        </p>
        <p className="mb-3">
          <strong>Cliente:</strong> {invoice.customer_name || "N/A"}
        </p>

        <Form.Group className="mb-3">
          <Form.Label>Motivo de Cancelación</Form.Label>
          <Form.Select
            value={motivo}
            disabled={loading}
            onChange={(e) => {
              setMotivo(e.target.value);
              if (e.target.value !== "01") {
                setUuidReemplazo("");
              }
            }}
          >
            {MOTIVO_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        {motivo === "01" && (
          <Form.Group className="mb-3">
            <Form.Label>UUID de Reemplazo</Form.Label>
            <Form.Control
              type="text"
              value={uuidReemplazo}
              disabled={loading}
              placeholder="UUID de la factura de reemplazo"
              onChange={(e) => setUuidReemplazo(e.target.value)}
            />
            <Form.Text muted>
              Obligatorio para el motivo 01.
            </Form.Text>
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cerrar
        </Button>
        <Button variant="danger" onClick={handleCancel} disabled={loading}>
          {loading ? "Cancelando..." : "Confirmar Cancelación"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CancelInvoiceModal;
